import {parseEventPayload} from '../helpdeskTicketsUtils';

/**
 * The customer's CSAT comment is stored as an INTERNAL_NOTE event whose
 * payload carries `source: 'csat'`. Always discriminate by that field —
 * don't infer from event order or proximity to TICKET_RESOLVED.
 */
export function extractCsatComment(events) {
  if (!Array.isArray(events)) return null;
  for (const event of events) {
    if (event?.eventType !== 'INTERNAL_NOTE') continue;
    const payload = parseEventPayload(event.payload);
    if (payload?.source === 'csat') {
      return {
        text: payload.text || '',
        scoreFromPayload:
          typeof payload.csatScore === 'number' ? payload.csatScore : null,
        createdAt: event.createdAt || null,
        eventId: event.id || null,
      };
    }
  }
  return null;
}

export function isCsatPayload(payload) {
  return !!payload && payload.source === 'csat';
}

/**
 * The comment to show for a ticket: the first-class `ticket.csatComment`
 * when set, else the legacy CSAT note in its events. Same `{text, ...}`
 * shape either way.
 */
export function ticketCsatComment(ticket) {
  const text = ticket?.csatComment?.trim();
  if (text) {
    return {text, scoreFromPayload: null, createdAt: null, eventId: null};
  }
  return extractCsatComment(ticket?.events);
}
